import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCampaignContent } from "services/api/campaign";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CampaignPost, CampaignPostsFilters, CampaignPostsState } from "types/campaign/posts";
import { generateUniqueKey, getErrorMessage, isFresh } from "utils/helpers";

export const fetchCampaignPostsThunk = createAsyncThunk<{campaignId: string, items: CampaignPost[], filters: CampaignPostsFilters, filterId: string, count: number}, {campaignId: string, filters: CampaignPostsFilters, force?: boolean}, {rejectValue: string}>(
    'campaign/content',
    async ({campaignId, filters, force=false}, {getState, rejectWithValue}) => {
        try {
             const STALE_TIME = apiConfig.FETCH_CAMPAIGN_CONTENT.staleTime;
            const filterId = generateUniqueKey(filters, ['page']);
            const state = getState() as { auth: AuthState, campaignPosts: CampaignPostsState };
            if (filters.page === 1 && !force && isFresh(state.campaignPosts.posts.items[campaignId]?.filtered_lists?.[filterId]?.last_fetched_at ?? null, STALE_TIME)) {
                return rejectWithValue(ERROR.CACHED);
            }
            const agencyId = state.auth.selectedAgency?.uuid ?? '';
            const {count, items} = await fetchCampaignContent(agencyId, campaignId, filters);
            return { items, filters, filterId, campaignId, count };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, 'failed to fetch campaign content'));
        }
    }
);